import useTranslation from '@/utils/hooks/translation/useTranslation';

import Button from '@/components/base/Button';
import Modal from '@/components/base/Modal';
import Tooltip from '@/components/base/Tooltip';

type FooterCrossPostProps = {
    toggle: () => void;
    onDelete: (deleteCrossPosts?: boolean) => void;
    isDeletingSinglePost: boolean;
    isDeletingCrossPost: boolean;
    masterPostIsReadOnly?: boolean;
};
export const FooterCrossPost = ({
    toggle,
    onDelete,
    isDeletingSinglePost,
    isDeletingCrossPost,
    masterPostIsReadOnly
}: FooterCrossPostProps) => {
    const { t } = useTranslation('scheduler');
    return (
        <Modal.Footer className="space-y-3 px-5 pb-12 pt-5 sm:px-12" divider={true}>
            <div className="flex items-center justify-between">
                <button
                    onClick={toggle}
                    className="text-xs text-icoGray-500 underline dark:text-icoDarkMode-wolf">
                    {t('commons:cancel')}
                </button>
                <div className="flex flex-col justify-between space-y-3 xs:flex-row xs:space-x-3 xs:space-y-0">
                    <Tooltip
                        content={
                            masterPostIsReadOnly
                                ? t('modal_delete_post_button_all_profiles_tooltip_read_only')
                                : ''
                        }>
                        <span>
                            <Button
                                data-testid="delete-all-profiles"
                                variant="secondary"
                                isLoading={isDeletingCrossPost}
                                disabled={isDeletingSinglePost || masterPostIsReadOnly}
                                onClick={() => onDelete(true)}
                                size="lg"
                                className="w-full whitespace-nowrap">
                                {t('modal_delete_post_button_all_profiles')}
                            </Button>
                        </span>
                    </Tooltip>
                    <Button
                        data-testid="delete-single-profile"
                        size="lg"
                        className="w-full whitespace-nowrap"
                        onClick={() => onDelete()}
                        isLoading={isDeletingSinglePost}
                        disabled={isDeletingCrossPost}>
                        {t('modal_delete_post_button_this_profile')}
                    </Button>
                </div>
            </div>
        </Modal.Footer>
    );
};
